"use strict";

define('libs/format/bold',['handlebars'], function (Handlebars) {
  return function (value) {
    return new Handlebars.SafeString('<b>' + Handlebars.escapeExpression(value) + '</b>');
  };
});

